// angular import
import { AfterViewChecked, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2 } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

// project import
import { ExportOptions, reportDesignerDto } from 'src/app/tabms/models/base/base';
import { BaseService } from 'src/app/tabms/services/base/base.service';
import { BaseAttachComponent } from '../../base-attach/base-attach.component';
import { BaseUploadTemplateComponent } from '../../base-upload-template/base-upload-template.component';
import { CommandService } from 'src/app/tabms/services/global/command.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseReportComponent } from '../../base-report/base-report.component';
import { Subject, takeUntil } from 'rxjs';
import { SessionWrapperService } from 'src/app/tabms/services/session/session-wrapper.service';
import { ThemeLayoutService } from 'src/app/@theme/services/theme-layout.service';
import { RTL } from 'src/app/@theme/const';
import { GridService } from '../../../global/shared-grid/service/grid.service';
import { ReportDesignService } from 'src/app/tabms/services/admin/report-design.service';

@Component({
  selector: 'app-base-create-tools',
  templateUrl: './base-create-tools.component.html',
  styleUrl: './base-create-tools.component.scss'
})
export class BaseCreateToolsComponent implements OnInit, OnDestroy {
  @Input() set service(_service) {
    if (!_service) return;
    this.serviceInstance = _service;
  }

  @Input() set fieldsConfigService(_fieldsConfigService) {
    if (!_fieldsConfigService) return;
    this.fieldsConfigServiceInstance = _fieldsConfigService;
  }
  @Input() canCreate: boolean = true;
  @Input() canEdit: boolean = true;
  //#endregion

  //#regoin public props
  serviceInstance;
  fieldsConfigServiceInstance;
  selectedReport: reportDesignerDto;
  selectedOption
  moreOptions: ExportOptions[]
    = [
      { value: 'tSave', viewValue: 'temporarySave' },
      // { value: 'attach', viewValue: 'attachments' },
      // { value: 'excelUpload', viewValue: 'uploadExcel' }
    ];
  reportsData: reportDesignerDto[];
  printListFields;
  //#endregion
  currentLang;
  extraDynamicMenu;
  systemMenuId;
  editId;
  displayListFields;
  menuKey: string;
  pageParameters: string;
  private destroy$: Subject<void> = new Subject<void>();

  // constructor
  constructor(
    private baseService: BaseService,
    private reportDesignerService: ReportDesignService,
    public dialog: MatDialog, private commandService: CommandService,
    private _router: Router, private activatedRoute: ActivatedRoute,
    private sessionService: SessionWrapperService,
    private themeLayoutService: ThemeLayoutService,
    private gridService: GridService
  ) {

    this.currentLang = this.baseService.getCurrentLanguage();
    this.themeLayoutService.directionChange.pipe(takeUntil(this.destroy$)).subscribe({
      next: (dir) => dir === RTL ? this.currentLang = 'ar' : this.currentLang = 'en'
    })

  }

  ngOnInit() {
    this.sessionService.menuKey$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        if (res) {
          this.menuKey = this.sessionService.getMenuKey();
          this.pageParameters = this.sessionService.getPageParameter();
          this.getReportData();
        }
      }
    })

    this.activatedRoute.params.pipe(takeUntil(this.destroy$)).subscribe({
      next: params => {
        this.systemMenuId = params['id'];
      }
    });

    this.getReportData();

    this.baseService.sendEditId.pipe(takeUntil(this.destroy$)).subscribe({
      next: (editId) => {
        this.editId = editId;
        if (this.editId && this.editId != null) this.moreOptions.push({ value: 'attach', viewValue: 'attachments' });
        else this.moreOptions = this.moreOptions.filter(x => x.value != 'attach');
      }
    });

    this.fieldsConfigServiceInstance.displayListSubject.pipe(takeUntil(this.destroy$)).subscribe({
      next: (value) => {
        this.displayListFields = value;
      }
    });

    this.fieldsConfigServiceInstance.printColumnsSubject.pipe(takeUntil(this.destroy$)).subscribe({
      next: (value) => {
        this.printListFields = value;
      }
    });

    this.getExtraDynamicMenu();
    // this.loadSessionValues();
    // this.sessionService.menuKey$.subscribe(() => {
    // this.loadSessionValues();
    // });

  }
  getReportData() {
    //debugger;
    this.reportDesignerService.getAllReportsByMenuKey(this.menuKey, this.pageParameters).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        if (res) {
          //  this.reportsData = res.result?.filter(x => x.tabsystemmenuid == this.systemMenuId);
          this.reportsData = res.result
          //
          if (this.reportsData && this.reportsData.length > 0) {
            const defaultReport = this.reportsData.filter(x => x.defaultreport);
            if (defaultReport && defaultReport.length > 0) {
              // debugger
              this.selectedReport = defaultReport[0];
            }
            else {
              this.selectedReport = this.reportsData[0];
            }
          } // set the selected value to default or first report
        }
      },
      error: (err) => {
      }
    });
  }
  private loadSessionValues() {
    this.menuKey = this.sessionService.getMenuKey();
    this.pageParameters = this.sessionService.getPageParameter();
  }
  //#region methods
  cancel() {
    this.clear();
    this.showHideCreateForm(false);
    this.baseService.sendEditId.next(null);
    this.gridService.setTableData([]);
  }

  clear() {
    this.baseService.clearForm.next(true);
    this.selectedOption = '';
    // this.selectedReport = '';
  }

  save() {
    this.baseService.saveForm.next(true);
    this.baseService.keepFormOpenOnSave.next(false);
    //this.cancel();
  }

  saveAndCopy() {
    this.baseService.keepFormOpenOnSave.next(true);
    this.baseService.saveForm.next(true);
  }

  reportNameSelect(report) {
    this.selectedReport = report;
  }

  //#region Export Options
  optionSelect(option: string) {
    this.selectedOption = option;
    // debugger
    switch (this.selectedOption) {
      case 'tSave':
        this.temporarySave();
        break;
      case 'attach':
        this.attach();
        break;
      // case 'excelUpload':
      //   this.uploadfromExcel();
      //   break;
      case 'addto':
        // this.commandService.exeStoredProcedure(row['id'], row['functionName']);
        break;
      default:
        //
        break;
    }
    // this.selectedOption = null;
  }

  loadMenu(e, value) {
    if (!e) {
      this.selectedOption = value;
      this.optionSelect(value);
    }

    if (e) this.selectedOption = null
  }


  //#endregion

  printReport() {
    // debugger;
    if (this.selectedReport)
      this.baseService.showReport.next(this.selectedReport);
    else
      this.baseService.showInfoMessage('PleaseSelectReport');
  }
  designReport() {
    // debugger;
    if (this.selectedReport)
      this.baseService.designReport.next(this.selectedReport);
    else
      this.baseService.showInfoMessage('PleaseSelectReport');
  }
  temporarySave() {
    this.baseService.saveRetrieveLocalData.next(1);
    this.baseService.showInfoMessage('DataSavedLocally');
    this.cancel();
  }

  showHideCreateForm(isVisible) {
    this.baseService.createFormDisplay.next({ 'show': isVisible, 'id': null });
  }

  attach() {
    this.dialog.open(BaseAttachComponent, {
      width: '800px',
      direction: this.baseService.getDirection(),
      data: { id: this.editId, menuKey: this.menuKey, pageParameter: this.pageParameters }
    });
  }

  uploadfromExcel() {
    this.baseService.uploadfromExcel.next(this.printListFields);
    /*     let extraDownloadProperties = ['password', 'empCode']; //this.formComponentInstance.beforeDownloadTemplateWork();
        this.dialog.open(BaseUploadTemplateComponent, {
          width: '800px',
          data: { service: this.serviceInstance, displayListFields: this.printListFields, extraDownloadProperties: extraDownloadProperties, type: 1 } // 1 for one row and 0 for list
        }); */
  }
  //#endregion

  //#region dynamic methods
  getExtraDynamicMenu() {
    this.commandService.getAll().pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        if (res.result && res.result.length > 0) {
          this.extraDynamicMenu = res.result.filter(x => x.tabsystemmenuid == this.systemMenuId && x.type == 1);
        }
      },
      error: (err) => {
      }
    });
  }

  //#endregion

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
